import tracking from "../../http/requests/tracking";

export default {
	fetchTrackings({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				tracking
					.getList(payload)
					.then(response => {
						resolve(response);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchTrackings]", error);
		}
	},
	fetchTracking({ commit }, tid) {
		try {
			return new Promise((resolve, reject) => {
				tracking
					.getDetail(tid)
					.then(response => {
						resolve(response);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchTracking]", error);
		}
	}
};
